<div class="modal-bg" *ngIf="isVisible ? true : false">
  <div class="modal">
    <h2 style="text-align: center;">{{ errorModal.title }}</h2>
    <div style="padding: 15px; min-height: 100px;">{{ errorModal.detail }}</div>
    <div style="text-align: center;" *ngIf="errorModal.isCloseBtn" (click)="errorModal.hideModal()">
      <ion-button color="secondary">{{systemLanguage | async | systemLanguages:routeId:'close'}}</ion-button>
    </div>
  </div>
</div>